import * as React from 'react'
import Skeleton from '@mui/material/Skeleton'
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material'

const CommunityListLoading = ({ loading }) => loading
  ? (
    <>
      <LoadingListItemButton width={140}/>
      <LoadingListItemButton width={120}/>
      <LoadingListItemButton width={166}/>
      <LoadingListItemButton width={130}/>
    </>
    )
  : undefined

const LoadingListItemButton = ({ width }) => (
  <ListItemButton>
    <ListItemIcon>
      <Skeleton animation="wave" variant="circular" width={24} height={24} />
    </ListItemIcon>
    <ListItemText sx={{ ml: -2 }}>
      <Skeleton animation="wave" height={21} width={166} />
    </ListItemText>
  </ListItemButton>
)

export default CommunityListLoading
